import {
  CartEntity,
  CartRepositoryContract,
  MakeOrderByCartResponseEntity,
  VariantEntity,
} from "@features/cart/domain";
import { CreateOrderPayload } from "@features/checkout/domain";
import { BaseRepository } from "@features/shared/data";
import { CART_API } from "../constants";
import { CartModel, CartSetProductModel, VariantProductModel } from "../models";

export class CartRepository
  extends BaseRepository
  implements CartRepositoryContract
{
  public async addProductToCart(
    id: string,
    desiredPrice: number,
    quantity: number,
  ): Promise<void> {
    await this.http.patch(CART_API.ADD_TO_CART_WITH_CUSTOM_PRICE_URL, {
      productId: id,
      price: desiredPrice,
      quantity,
    });
  }

  public async getUserCart(): Promise<CartEntity> {
    const response = await this.http.get<CartModel>(CART_API.GET_USER_CART);
    return response.data.data;
  }

  public async setUserCart(data: CartSetProductModel[]): Promise<void> {
    await this.http.patch(CART_API.SET_USER_CART, data);
  }

  public async deleteUserCartProduct(productId: string): Promise<void> {
    await this.http.patch(CART_API.DELETE_USER_CART_PRODUCT(productId), {});
  }

  public async getProductsByProductIds(
    productIds: string[],
  ): Promise<VariantEntity[]> {
    const response = await this.http.post<string[], VariantProductModel>(
      CART_API.GET_PRODUCT_BY_PRODUCTIDS,
      productIds,
    );
    return response.data.data;
  }

  public async makeOrderByCart(
    data: CreateOrderPayload,
  ): Promise<MakeOrderByCartResponseEntity> {
    const response = await this.http.post<
      CreateOrderPayload,
      MakeOrderByCartResponseEntity
    >(CART_API.MAKE_ORDER_BY_CART, data);
    return response.data;
  }
}
